const state = {
  selectedDate: ''
}

const modules = {}

const getters = {
  selectedDate: state => state.selectedDate
}

const mutations = {
  setSingleProperty: (state, [prop, value]) => {
    state[prop] = value
  }
}

const actions = {
  setDate({ commit }, date) {
    commit('setSingleProperty', ['selectedDate', date])
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
  modules
}
